import request from "@/utils/request/request";

export default {
  //查询客户管理列表
  getClientList(params) {
    return request({ url: "abount/introduce", method: "get", params });
  },
  //获取轮播图
  getImgList(params) {
    return request({ url: "index/banner", method: "get", params });
  },
};



// WEBPACK FOOTER //
// ./src/api/index.js